import {
  AuthActions,
  LOGIN,
  LOGIN_FAILED,
  LOGIN_FINISHED, SIGN_OUT_FINISHED,
  SIGN_UP,
  SIGN_UP_FAILED,
  SIGN_UP_FINISHED} from './authentication-actions';
import {UserInfo} from 'firebase';

export interface AuthenticationState {
    user: UserInfo;
    signUpError;
    loginError;

}

export const initialState = {
    user: null,
    signUpError: '',
    loginError: ''
};

export function reducer(state: AuthenticationState= initialState, action: AuthActions): AuthenticationState {
    switch (action.type) {
        case LOGIN:
            return initialState;
        case SIGN_UP_FINISHED:
            return Object.assign({}, state, {user: action.payload} );
      case SIGN_UP:
          return Object.assign({}, state, {signUpError: '', loginError: ''});
      case SIGN_UP_FAILED:
        return Object.assign({}, state, {signUpError: action.payload, loginError: ''});
      case LOGIN_FAILED:
        return Object.assign({}, initialState, {loginError: action.payload});
      case LOGIN_FINISHED:
        return Object.assign({}, initialState, {user: action.payload});
      case SIGN_OUT_FINISHED:
        console.log('signing out');
        return Object.assign({}, initialState);
        default:
            return state;
    }
}
